























import Vue from 'vue';
import {
  booth,
  Booth,
  item,
  Item,
  brand,
  Brand,
} from 'mostra';
import * as page from '@/modules/page';
const pageParams = page.tabParams.booth;

interface DataType {
  owner: string | null
  isChanged: boolean
  loading: boolean;
  targetPageName: string;
  editPageName: string;
  booth: Booth | null;
  items: Item[];
  brands: Brand[];
  // currentPage: string | null;
  // currentSubPage: string | null;
  footerButtonText: string;
  notFound: boolean;
}

export default Vue.extend({
  name: 'exhibitor-booth-new',
  data(): DataType {
    return {
      owner: null,
      isChanged: false,
      loading: true,
      targetPageName: 'exhibitor-booth-new',
      editPageName: 'exhibitor-booth-edit',
      booth: null,
      items: [],
      brands: [],
      // currentPage: null,
      footerButtonText: '',
      notFound: false,
    };
  },
  computed: {
    boothId(): string | null {
      return this.$route.query.id as string;
    },
    currentPage(): string | null {
      return this.$route.query.page as string;
    },
  },
  watch: {
    booth: {
      handler(_, oldVal: any) {
        if (oldVal) {
          this.isChanged = true;
        }
      },
      deep: true,
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (this.isChanged) {
      const r = await (this.$refs.dialog as any).show();
      next(r);
    } else {
      next();
    }
  },
  methods: {
    async toUpdateData() {
      try {
        this.$loading(true);
        if (!this.booth) {
          throw Error('this.booth is null');
        }
        const uid = this.$auth.uid;
        const r = await booth.save(uid, this.booth);
        this.booth = r;
        this.isChanged = false;
        this.$router.push({
          name: this.editPageName,
          query: {
            page: 'preview',
            id: r.id,
          },
        });
        this.$success('保存しました。');
      } catch (error: any) {
        this.$error('保存に失敗しました。', error);
      } finally {
        this.$loading(false);
      }
    },
    async fetchData() {
      try {
        if (this.booth) return;
        this.loading = true;
        this.$loading(true);
        this.owner = this.$auth.cid;
        if (!this.owner) {
          throw Error('owner is null');
        }
        this.booth = booth.createNewBooth(this.owner);
        this.items = await item.loadsByOwner(this.owner);
        this.brands = await brand.loadsByOwner(this.owner);
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    checkParamsValid() {
      if (!this.currentPage || !pageParams.includes(this.currentPage)) {
        this.$router.push({
          name: this.targetPageName,
          query: {
            ...this.$route.query,
            page: 'settings',
          },
        });
      }
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    this.checkParamsValid();
    await this.fetchData();
  },
  async mounted() {
    this.checkParamsValid();
    await this.fetchData();
  },
});
